/* Ralat sambungan webapp ⇄ extension (2026-09-26).
   Mesej mentah Chrome ("The message port closed before a response was received",
   "Receiving end does not exist", "Extension context invalidated") tidak bermakna
   kepada pelanggan. Diukur 26 Sept: selepas extension unpacked dikemas kini di
   cakera, refresh halaman memuat content script BAHARU tetapi service worker kekal
   LAMA sehingga "Reload" di chrome://extensions — refresh/hard refresh tidak
   membaikinya. Ayat pelanggan (arahan user 26 Sept) menyuruh Reload extension. */

const CORAK_SAMBUNGAN = /context invalidated|Receiving end does not exist|message port closed|No response/i;

export const adalahRalatSambungan = (mesej) => CORAK_SAMBUNGAN.test(String(mesej || ''));

/** Jalankan `fn` (pulang { success, error }); ralat sambungan dicuba semula SEKALI
 *  selepas `jedaMs` (service worker yang baru bangun). HANYA untuk kerja yang selamat
 *  diulang (baca senarai) — bukan larian agent. */
export async function cubaSemulaSambungan(fn, jedaMs = 1000) {
    const r = await fn();
    if (r?.success || !adalahRalatSambungan(r?.error)) return r;
    await new Promise(res => setTimeout(res, jedaMs));
    return fn();
}
